import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Radio } from '@mui/material';

function QuestionsTable({ questions, answerOptions, answers, whiteSpace, onAnswerChange, questionOffset = 0 }) {
  // Determine answer options for this block (assumes all questions in the block use the same options)
  let options = answerOptions;
  if (
    answerOptions &&
    typeof answerOptions === 'object' &&
    !Array.isArray(answerOptions) &&
    questions[0] &&
    questions[0].answerOptions
  ) {
    options = answerOptions[questions[0].answerOptions] || [];
  }

  return (
    <TableContainer sx={{mb: 6}}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell />
            {options.map((option) => (
              <TableCell
                key={option.value}
                align="center"
                sx={{ whiteSpace }}
              >
                {option.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {questions.map((question, qIndex) => (
            <TableRow key={qIndex}>
              <TableCell>
                {qIndex + 1 + questionOffset}. {question.text}
              </TableCell>
              {options.map((option) => (
                <TableCell
                  key={option.value}
                  align="center"
                >
                  <Radio
                    checked={answers[qIndex] === option.value}
                    onChange={
                      onAnswerChange === null ? null :
                      () => onAnswerChange(qIndex, option.value)
                    }
                    value={option.value}
                    name={`question-${qIndex}`}
                    color="primary"
                    disableRipple={onAnswerChange === null}
                    disableFocusRipple={onAnswerChange === null}
                    disableTouchRipple={onAnswerChange === null}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default QuestionsTable;